export default __webpack_public_path__ + "static/media/nu-tone-nz.4ef63726.mp3";